// Cart page: swap a line item to another variant of the same product.
(function () {
  function readJSON(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent) || fallback;
    } catch (e) {
      return fallback;
    }
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
        return data;
      });
    });
  }

  function init(root) {
    // Toggle lives under the item's options; the panel and its spacer are a separate row below the item.
    var toggle = document.querySelector('[data-cart-item-edit-toggle="' + root.id + '"]');
    var rows = Array.prototype.slice.call(document.querySelectorAll('[data-cart-item-edit-row="' + root.id + '"]'));
    if (!toggle || !rows.length) return;
    var selects = Array.prototype.slice.call(root.querySelectorAll('select[data-option-index]'));
    var saveBtn = root.querySelector('[data-cart-item-edit-save]');
    var cancel = root.querySelector('[data-cart-item-edit-cancel]');
    var errorEl = root.querySelector('[data-cart-item-edit-error]');
    var variants = readJSON(root, '[data-cart-item-edit-variants]', []);
    var properties = readJSON(root, '[data-cart-item-edit-properties]', {});
    var currentId = Number(root.dataset.variantId);
    var quantity = Number(root.dataset.quantity) || 1;
    var saveLabel = saveBtn.textContent;

    function selected() {
      return selects.map(function (s) { return s.value; });
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return opts.every(function (val, i) { return v.options[i] === val; });
      });
    }

    function sameProperties(a) {
      var norm = function (p) { return p && !Array.isArray(p) ? JSON.stringify(p) : '{}'; };
      return norm(a) === norm(properties);
    }

    function getCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (res) { return res.json(); });
    }

    // Liquid renders empty properties as [], which /cart/add.js rejects, so only attach a non-empty object.
    function withProperties(line) {
      if (properties && !Array.isArray(properties) && Object.keys(properties).length) line.properties = properties;
      return line;
    }

    // Total quantity of the original variant; automatic discounts can split it across several cart lines.
    function originalTotal(items) {
      return items.reduce(function (sum, it) {
        return it.variant_id === currentId && sameProperties(it.properties) ? sum + it.quantity : sum;
      }, 0);
    }

    // Line keys change when discounts re-apply, so fall back to the first line of the same variant.
    function findOriginalLine(items) {
      var byKey = items.findIndex(function (it) { return it.key === root.dataset.key; });
      if (byKey !== -1) return byKey;
      return items.findIndex(function (it) { return it.variant_id === currentId && sameProperties(it.properties); });
    }

    // Bring the original variant down to `expected`, re-reading the cart after each change to confirm.
    function settleOriginal(expected, attempt) {
      return getCart().then(function (cart) {
        var total = originalTotal(cart.items);
        if (total === expected) return;
        if (attempt >= 3) throw new Error('Could not update the original item. Please check your cart.');
        if (total < expected) {
          return postJSON('/cart/add.js', { items: [withProperties({ id: currentId, quantity: expected - total })] })
            .then(function () { return settleOriginal(expected, attempt + 1); });
        }
        var idx = findOriginalLine(cart.items);
        // First try treats discount-split lines as one line and sets the whole total; retries trim only this line.
        var qty = attempt === 0 ? expected : Math.max(0, cart.items[idx].quantity - (total - expected));
        return postJSON('/cart/change.js', { line: idx + 1, quantity: qty })
          .then(function () { return settleOriginal(expected, attempt + 1); });
      });
    }

    function showError(msg) {
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    }

    // Label option values that are sold out given the other current selections.
    function refresh() {
      var opts = selected();
      selects.forEach(function (select, idx) {
        Array.prototype.forEach.call(select.options, function (opt) {
          var trial = opts.slice();
          trial[idx] = opt.value;
          var v = findVariant(trial);
          var soldOut = !v || !v.available;
          opt.textContent = opt.value + (soldOut ? ' (Sold out)' : '');
        });
      });
      var variant = findVariant(opts);
      showError('');
      if (!variant) {
        saveBtn.disabled = true;
        showError('This combination is not available.');
      } else if (!variant.available && variant.id !== currentId) {
        saveBtn.disabled = true;
        showError('This option is sold out.');
      } else {
        saveBtn.disabled = false;
      }
    }

    function setOpen(open) {
      rows.forEach(function (row) { row.hidden = !open; });
      toggle.setAttribute('aria-expanded', String(open));
      toggle.hidden = open;
      if (open) refresh();
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      setOpen(true);
    });

    cancel.addEventListener('click', function (e) {
      e.preventDefault();
      selects.forEach(function (s) {
        var def = Array.prototype.find.call(s.options, function (o) { return o.defaultSelected; });
        if (def) s.value = def.value;
      });
      showError('');
      setOpen(false);
    });

    selects.forEach(function (s) { s.addEventListener('change', refresh); });

    saveBtn.addEventListener('click', function () {
      var variant = findVariant(selected());
      if (!variant) return;
      if (variant.id === currentId) {
        setOpen(false);
        return;
      }
      saveBtn.disabled = true;
      saveBtn.textContent = 'Saving...';
      showError('');

      var expected;

      // Add the new variant first so a failed add never drops the original line.
      getCart()
        .then(function (cart) {
          expected = Math.max(0, originalTotal(cart.items) - quantity);
          return postJSON('/cart/add.js', { items: [withProperties({ id: variant.id, quantity: quantity })] });
        })
        .then(function () {
          return settleOriginal(expected, 0);
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function (err) {
          saveBtn.disabled = false;
          saveBtn.textContent = saveLabel;
          showError(err.message);
        });
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-item-edit]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
